const formatString = (str: string): string => {
    const lc = str.toLowerCase();
    const spl = lc.split(" ");
    return spl.join("-");
}
export default formatString;